'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgHeartFill } from '@common/icon';
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import { Image } from '@/components/client';
import BorderImage from './_assets/donation-certificate-border.png';
interface CertificateCardProps {
  name: string;
  paidAt: string;
  donationAmount: number;
  className?: string;
}
export const CertificateCard = t0 => {
  const $ = _c(30);
  const {
    name,
    paidAt,
    donationAmount,
    className,
    ref
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative h-[408px] w-280 overflow-hidden rounded-large bg-gradient-to-br from-Pink-50 to-O-50 shadow-lg flex-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="size-full animate-spin bg-gradient-to-r from-R-200 to-R-300 animate-duration-[5000ms] animate-infinite" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src={BorderImage} alt={"\uAE30\uBD80\uC99D\uC11C \uD14C\uB450\uB9AC"} className="absolute left-10 top-10" width={260} height={388} placeholder="blur" />;
    t4 = <SvgHeartFill className="mb-12 size-32 text-R-300 opacity-60" />;
    t5 = <p className="pb-36 font-800 text-Gray-900 typo-h5">기부증서</p>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="w-62 font-400 text-Gray-600 typo-body4">기부자</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== name) {
    t7 = <li className="flex items-center gap-20">{t6}<span className="font-600 text-Gray-800 typo-body4">{name}</span></li>;
    $[7] = name;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="w-62 font-400 text-Gray-600 typo-body4">기부일자</p>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== paidAt) {
    t9 = dayjs(paidAt).format("YYYY.MM.DD");
    $[10] = paidAt;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <li className="flex items-center gap-20">{t8}<span className="font-600 text-Gray-800 typo-body4">{t9}</span></li>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="w-62 font-400 text-Gray-600 typo-body4">기부금액</p>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== donationAmount) {
    t12 = donationAmount.toLocaleString();
    $[15] = donationAmount;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12) {
    t13 = <li className="flex items-center gap-20">{t11}<span className="font-600 text-Gray-800 typo-body4">{t12}원</span></li>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10 || $[20] !== t13 || $[21] !== t7) {
    t14 = <ul className="flex flex-col gap-8 pb-54">{t7}{t10}{t13}</ul>;
    $[19] = t10;
    $[20] = t13;
    $[21] = t7;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="text-center font-400 text-R-300 typo-caption1">조금이라도 도움이 되길<br />바라는 마음으로 기부합니다.</p>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== ref || $[25] !== t14) {
    t16 = <div className="absolute left-1 top-1 m-auto flex size-[calc(100%-2px)] flex-col items-center rounded-large bg-[linear-gradient(154deg,#FFF0F9_0%,#FFF2E8_97.94%)] pt-55" ref={ref}>{t3}{t4}{t5}{t14}{t15}</div>;
    $[24] = ref;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t1 || $[28] !== t16) {
    t17 = <article className={t1}>{t2}{t16}</article>;
    $[27] = t1;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};